import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_INVESTMENT_TIMELINE } from "../../../config/api";

export const deleteTimeline = createAsyncThunk(
  "timeline/delete",
  async ({ cb, id, failed }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "DELETE",
        path: `${API_INVESTMENT_TIMELINE}/${id}`,
      });
      toast.success("Timeline deleted successfully");

      cb();
      return id;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      return rejectWithValue(error.message);
    }
  }
);
